import { t } from "ttag";

import { NoDataError } from "metabase/common/components/errors/NoDataError";
import { Tooltip } from "metabase/ui";

import { Root, ShortMessage } from "./NoResultsView.styled";

interface NoResultsViewProps {
  isSmall?: boolean;
  isDashboard?: boolean;
  hasAppliedFilters?: boolean;
}

// DX-Comment: Updated function to get custom message for filters case
function NoResultsView({
  isSmall,
  isDashboard,
  hasAppliedFilters,
}: NoResultsViewProps) {
  const message = !isDashboard
    ? t`No results!`
    : hasAppliedFilters
      ? t`No data available for selected filters. Kindly re-apply and check.`
      : t`No data available.`;

  return (
    <Root>
      <Tooltip label={message} disabled={!isSmall}>
        <span>
          <NoDataError data-testid="no-results-image" mb="1rem" />
        </span>
      </Tooltip>
      {!isSmall && <ShortMessage>{message}</ShortMessage>}
    </Root>
  );
}

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default NoResultsView;
